<template>
  <v-dialog v-model="dialog" max-width="500">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        text
        dark
        v-bind="attrs"
        v-on="on"
        class="mb-4"
        :disabled="isDisabled"
      >
        <v-avatar
          :style="{ backgroundColor: isDisabled ? '#aaa' : '#27362F' }"
          class="pa-2 cursor-pointer"
          @click="openMenuPrinter"
        >
          <img src="@/assets/i/icon-printer-w.svg" />
        </v-avatar>
      </v-btn>
    </template>
    <v-card class="pb-1">
      <v-card-title class="mb-n4" v-if="step === 1">
        {{ $t("lang.inbound.dashboard.title_select_tab") }}
      </v-card-title>
      <v-card-title class="mb-n4" v-if="step === 2">
        {{ $t("lang.inbound.dashboard.title_select_tag_format") }}
      </v-card-title>
      <v-card-title class="mb-n4" v-if="step === 3">
        {{ $t("lang.inbound.dashboard.title_order_or_print") }}
      </v-card-title>
      <v-divider></v-divider>

      <v-card-text class="select-tag" style="height: 230px" v-if="loading">
        <PuSkeleton :duration="1.5" height="25px" width="180px"></PuSkeleton>
      </v-card-text>

      <v-card-text style="height: 230px" v-else-if="step === 1">
        <v-select
          v-if="tags.length > 0"
          :items="tags"
          item-text="tag_type.reference"
          item-value="tag_type.id"
          v-model="selectedTag"
          prefix="Tag Type :   "
        ></v-select>
      </v-card-text>

      <v-card-text style="height: 230px" v-else-if="step === 2">
        <v-select
          v-if="tagFormats.length > 0"
          :items="tagFormats"
          item-text="tag_format.description"
          item-value="tag_format.id"
          v-model="selectedTagFormat"
          prefix="Tag Format :   "
        ></v-select>
      </v-card-text>

      <v-card-text style="height: 230px" v-else-if="step === 3">
        <v-radio-group v-model="type" @change="changeType" column>
          <v-row>
            <v-col cols="4">
              <v-radio
                value="order"
                :label="$t('lang.inbound.dashboard.label_order')"
                color="#9ac31c"
              ></v-radio>
            </v-col>
            <v-col cols="8">
              <v-radio
                value="print"
                :label="$t('lang.inbound.dashboard.label_print')"
                color="#9ac31c"
              ></v-radio>
            </v-col>
          </v-row>
        </v-radio-group>
        <v-row class="mt-n6">
          <v-col></v-col>
          <v-col>
            <v-select
              :items="printers"
              item-text="description"
              item-value="id"
              v-model="selectedPrinter"
              :disabled="!type || type !== `print`"
              :label="$t('lang.inbound.dashboard.label_printer')"
              outlined
              hide-details="auto"
              dense
            ></v-select>

            <v-row class="print-qty mt-3 py-0 h-auto" aria-disabled="true">
              <v-radio-group v-model="qtyGroup" class="m-0 p-0" hide-details>
                <v-col>
                  <v-radio
                    value="all"
                    :label="$t('lang.inbound.dashboard.label_all')"
                    color="#9ac31c"
                    class="mb-0"
                    :disabled="!type || type !== `print` || !selectedPrinter"
                  ></v-radio>
                </v-col>
                <v-col class="d-flex flex-row align-center">
                  <v-radio
                    value="qty"
                    :label="$t('lang.inbound.dashboard.label_from')"
                    color="#9ac31c"
                    class="mb-0"
                    :disabled="!type || type !== `print` || !selectedPrinter"
                  >
                  </v-radio>
                  <v-text-field
                    type="number"
                    :rules="rules"
                    :value="qtyFrom"
                    v-model="qtyFrom"
                    outlined
                    dense
                    class="px-0 pl-2"
                    :disabled="
                      !type ||
                        type !== `print` ||
                        !selectedPrinter ||
                        qtyGroup !== 'qty'
                    "
                  ></v-text-field>
                  <span
                    class="mx-2"
                    :style="{
                      color:
                        !type ||
                        type !== `print` ||
                        !selectedPrinter ||
                        qtyGroup !== 'qty'
                          ? '#aaa'
                          : '#000'
                    }"
                    >to</span
                  >
                  <v-text-field
                    type="number"
                    :rules="rules"
                    :value="qtyTo"
                    v-model="qtyTo"
                    outlined
                    dense
                    class="p-0"
                    :disabled="
                      !type ||
                        type !== `print` ||
                        !selectedPrinter ||
                        qtyGroup !== 'qty'
                    "
                  ></v-text-field>
                </v-col>
              </v-radio-group>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between mt-n3">
        <v-btn color="#717C7D" text @click="close">{{
          $t("lang.inbound.dashboard.btn_close")
        }}</v-btn>
        <v-btn color="primary" @click="next" :disabled="checkIsDisabled">
          {{ nextBtnLabel }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    isDisabled: Boolean,
    selectedRecords: Array
  },
  async mounted() {
    this.user = await this.$api.printer.printer_user(
      this.$store.state.user.user
    );
  },
  data() {
    return {
      loading: false,
      user: null,
      step: 1,
      tags: [],
      tagFormats: [],
      printers: [],
      dialog: false,
      type: null,
      qtyGroup: "all",
      selectedTag: null,
      selectedTagFormat: null,
      selectedPrinter: null,
      isLoad: false,
      company: null,
      printerCompany: null,
      companyFormat: null,
      itemsPerPage: process.env.VUE_APP_GTIN_PER_PAGE,
      page: 1,
      totalQuantity: 0,
      name:null,
      items: [],
      qtyFrom: 1,
      qtyTo: 500,
      rules: [
        v => !!v || this.$t("lang.inbound.dashboard.error_required"),
        v => v > 0 || this.$t("lang.inbound.dashboard.error_min"),
        v => v <= 500 || this.$t("lang.inbound.dashboard.error_max")
      ]
    };
  },
  computed: {
    checkIsDisabled() {
      if (this.step === 1 && this.selectedTag !== null) return false;
      if (this.step === 2 && this.selectedTagFormat !== null) return false;
      if (
        (this.step === 3 && this.type === "order") ||
        (this.step === 3 &&
          this.type === "print" &&
          this.selectedPrinter !== null)
      ) {
        return false;
      }
      return true;
    },
    showSideMenu: {
      get() {
        return this.$store.getters.showSideMenu;
      },
      set(data) {
        this.$store.dispatch("setSideMenu", data);
      }
    },
    nextBtnLabel() {
      if (this.step && this.step === 3 && this.type === "print") {
        return this.$t("lang.inbound.dashboard.label_print");
      } else {
        return this.$t("lang.inbound.dashboard.btn_next");
      }
    }
  },
  methods: {
    async openMenuPrinter() {
      this.loading = true;
      this.tags = await this.$api.printer.printer_tagtype();
      this.loading = false;
      this.dialog = true;
    },
    print() {
      this.$emit("print", this.printer);
      this.dialog = false;
      this.step = 1;
    },
    async changeType() {
      // this.nextBtnLabel();
      this.isLoad = false;
      const porder = await Promise.all(
        this.selectedRecords.map(order =>
          this.$api.porders.report(order.id, {})
        )
      );
      console.log(porder)
      const items = porder.map((order, i) => {
        const data = order.map(el => ({ ...el, quantity: el.real_quantity }));
        const obj = [...data];
        this.name = order.id;
        return { ...obj };
      });
      const arr = [];
      items.map(el => {
        return Object.entries(el).forEach(([key, val]) => {
          arr.push(val);
        });
      });
      const total_quantity = this.selectedRecords.reduce(
        (acc, val) => acc + val.item_count,
        0
      );
      this.items = arr;
      this.totalQuantity = total_quantity;
      this.isLoad = false;
    },
    async next() {
      if (this.step < 3) {
        this.step++;
      }
      if (this.step === 2) {
        this.loading = true;
        this.tagFormats = await this.$api.printer.printer_tagtype({
          tag_type: this.selectedTag
        });
        this.loading = false;
      }
      if (this.step === 3) {
        this.printers = [];
        this.printers = await this.$api.printer.printer_list();
        this.printerCompany = await this.$api.printer.getPrinterCompany();
        this.companyFormat = await this.$api.printer.printer_tagtype({
          tag_type: this.selectedTag,
          tag_format: this.selectedTagFormat,
          limit: 10
        });

        if (this.type === "print") {
          this.company = await this.$api.printer.getPrinterCompanyByFilter(
            "CLIENT"
          );
          const res = await this.$api.printer.set_print_order({
            companyformat_id: this.companyFormat.results[0].id,
            responsible_id: this.user.company,
            total_quantity: this.totalQuantity,
            items: this.items,
            name: this.name
          });
          if (this.selectedPrinter && res) {
            const payload = {
              printorder_id: res.print_order,
              print_id: this.selectedPrinter,
              from: this.qtyFrom,
              to: this.qtyTo
            };
            if (this.qtyGroup === "all") {
              delete payload.from;
              delete payload.to;
            }
            await this.$api.printer.printer_print(payload);
            await this.$api.printer
              .printer_tagtype({
                tag_type: this.selectedTag,
                tag_format: this.selectedTagFormat
              })
              .then(() => (this.showSideMenu = "printer_menu"));

            this.$router.push({
              name: "PrintOrderList",
              params: { printer: this.selectedPrinter }
            });
          }
        } else if (this.type === "order") {
          this.company = await this.$api.printer.getPrinterAdminCompany();
          await this.$api.printer.set_print_order({
            companyformat_id: this.companyFormat.results[0].id,
            responsible_id: this.company[0].id,
            total_quantity: this.totalQuantity,
            items: this.items,
            name: this.name
          });
          await this.$api.printer
            .printer_tagtype({
              tag_type: this.selectedTag,
              tag_format: this.selectedTagFormat,
              limit: 10
            })
            .then(() => (this.showSideMenu = "printer_menu"));

          this.$router.push({
            name: "PrintOrderList",
            params: {
              printer: this.selectedPrinter,
              id: this.selectedRecords[0].id
            }
          });
          this.close();
        }
      }
    },
    close() {
      this.dialog = false;
      this.step = 1;
      this.type = null;
      this.selectedTag = null;
      this.selectedPrinter = null;
      this.company = null;
      this.printerCompany = null;
      this.companyFormat = null;
      this.totalQuantity = 0;
      this.items = [];
    }
  }
};
</script>

<style scoped>
.select-tag > .v-text-field__prefix {
  margin-right: 1rem !important;
  background: #aaa !important;
}
</style>
